import { NavigationModel } from "models/NavigationModel";

import { getLinkTextKnowHow, getLinkTextManual } from "./translations";

export function getHelpLinks(): NavigationModel[] {
  return [
    {
      href: "https://confluence.sbb.ch/pages/viewpage.action?pageId=2365819294",
      text: getLinkTextManual(),
      iconStart: (
        <span className="svg-Icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M0.0980652 14.5317H5.81699C12.3572 14.5317 12.6979 14.4696 14.2761 12.9934C17.5355 9.94473 15.9174 4.3325 11.5652 3.59186L10.7859 3.45929L10.7878 0H0L0.0980652 14.5317ZM10 3.51172H10.0782L9.2684 3.65617C6.71476 4.22975 5.05571 6.37613 5.07521 9.08052C5.0889 10.9856 5.81455 12.3906 7.36447 13.5132L7.5 13.597H4.34507L1 13.5501L0.999999 0.953124L5.44985 1H10L10 3.51172ZM12.7386 4.5217C15.3031 5.8033 16.2813 8.7477 14.9969 11.3197C14.5007 12.3131 13.8657 12.9257 12.6827 13.552C11.5916 14.1295 9.41597 14.1285 8.32319 13.5501C5.94862 12.2934 4.89783 9.68673 5.80124 7.29434C6.89477 4.39888 10.0049 3.15572 12.7386 4.5217ZM10.2547 6.68776C9.91586 7.02658 10.2684 7.68773 10.7878 7.68773C11.018 7.68773 11.4078 7.06634 11.3205 6.83852C11.2134 6.55988 10.4855 6.45694 10.2547 6.68776ZM10.0782 8.32843C9.7576 8.64907 9.28734 10.7392 9.44391 11.1472C9.6946 11.8007 11.6297 11.2115 11.6297 10.4819V10.0981L11.1356 10.4866C10.2297 11.1993 10.1917 11.0741 10.6128 8.76589C10.7497 8.01661 10.5519 7.8548 10.0782 8.32843Z"
              fill="currentColor"
            />
            <path d="M2 4V3H7.21149V4H2Z" fill="currentColor" />
            <path d="M2 6V5H5V6H2Z" fill="currentColor" />
            <path d="M2 8V7H4V8H2Z" fill="currentColor" />
            <path d="M2 10V9H4V10H2Z" fill="currentColor" />
            <circle cx="10.5" cy="9" r="5" stroke="currentColor" />
          </svg>
        </span>
      ),
      isSelected: false,
      target: "_blank",
    },
    {
      href: "https://confluence.sbb.ch/spaces/EGPL/pages/2684952920/Anleitungsartikel",
      text: getLinkTextKnowHow(),
      iconStart: <i className="ms-Icon ms-Icon--SentimentAnalysis" />,
      isSelected: false,
      target: "_blank",
    },
  ];
}
